import { LabelledRadioButton } from '@adserve/adserve-react-components';
import React from 'react';

const CreateQuoteRadioButton = ({ id, title, value, onClick }) => {
    return <LabelledRadioButton id={id} size={20} value={value} onClick={onClick} title={title} gap={10} reverseElements />;
};

export default CreateQuoteRadioButton;
